import React from 'react';

import { VpTablePagination } from '../../';
import { useFetchPlugins } from '../../../hooks';

export const VpPluginsTablePagination = () => {
  const { data } = useFetchPlugins();
  const pageData = {
    meta: data?.recordMetadata
  };
  return <VpTablePagination data={pageData} />;
};

export default VpPluginsTablePagination;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginsTable/VpPluginsTablePagination.jsx